<template>
  <div id="faq">

    <div class="controls">
      <input
        id="searchinput"
        placeholder="Dúvidas? Faça uma busca aqui!!!"
        type="text"
        v-model="searchLinkFilter"
      >
    </div>

    <div class="faq">
      <ul>
        <li
          v-for="link in filteredQuestions"
          :key="link.key"
        >
          <h3>
            {{ link.perg }}
          </h3>
          
          <p>
            {{ link.resp }}
          </p>
        </li>

        <li v-if="filteredQuestions.length < 1">
          <p>
            Não encontramos nada...
          </p>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Faq',

    props: [
      'faqQuestions',
    ],
    
    data: function() {
      return {
        categories: [],
        searchLinkFilter: '',
        categoryLinkFilter: '',
      }
    },

    computed: {
      filteredQuestions() {
        return this.faqQuestions.filter((link)  => {
          return link.category.match(this.categoryLinkFilter)
        }).filter((item) => {
          return item.perg.match(new RegExp(this.searchLinkFilter, "ig")) || item.resp.match(new RegExp(this.searchLinkFilter, "ig"))
        })
      }
    },

    methods: {
      clearFilter() {
        this.searchLinkFilter = '';
        this.categoryLinkFilter = '';
      },

      getCategories() {
        this.faqQuestions.forEach((link) => {
          if(!this.categories.includes(link.category)) {
            this.categories.push(link.category);
          }
        });
        for (var link in this.faqQuestions) {
          if (this.categories.indexOf(this.faqQuestions[link].category) == -1){
              this.categories.push(this.faqQuestions[link].category);
            }
        }
      },

      deleteItem(index) {
        if (confirm('É sério isso?')) {
          this.faqQuestions.splice(index, 1);
        }
      }
    },
    
    created() {
      this.getCategories()
    }
  }
</script>

<style scoped lang="scss">
  /* Sizes */
  $baseWidth: 1150px;

  /* Variables */
  $red: #990000;

  #faq {
    .controls {
      input {
        width: 100%;
        padding: 15px;
        background: transparent;
        border: 0;
        border-bottom: 2px solid #990000;
        margin-bottom: 20px;
        background: #FFFFFF;
      }
    }

    .faq {
      ul {
        li {
          margin-bottom: 20px;
          border-bottom: 1px solid #000000;
          padding-bottom: 10px;
          &:before {
            display: none;
          }
          
          h3 {
            font-family: 'Eagle Lake', cursive;
            line-height: 30px;
            letter-spacing: 1px;
            font-weight: bolder;
            font-size: 20px;
            color: $red;
            margin: 30px 0 5px 0;
            display: block;
          }
          p {
              font-family: 'Gochi Hand', cursive;
              font-size: 18px;
              line-height: 24px;
              letter-spacing: 1.5px;
              margin: 5px 0 10px 0;
              text-align: justify;
              text-justify: inter-word;
          }
        }
      }
    }
  }
</style>